















import { Component, Mixins } from "vue-property-decorator";
import { WebStorageAccessor } from "../../../../store/WebStorageAccessor";
import { LogableMixin } from "../logging/mixins";
import LogViewer from "../logging/LogViewer.vue";
import { WebStorageKeys } from "../../../../store/WebStorageKeys";

@Component({
  components: {
    LogViewer,
  }
})
export default class HostNameEditor extends Mixins(LogableMixin) {
  data(): any {
    return {
      source: null,
    };
  }
  source: string;

  mounted(): void {
    WebStorageAccessor.addUpdateEventListener(WebStorageKeys.hostName, (e: StorageEvent) => {
      if (this.source !== e.newValue) {
        this.source = e.newValue;
        this.pushLog("更新されました. " + e.newValue);
      }
    });
    this.source = WebStorageAccessor.hostName;
  }

  apply(): void {
    WebStorageAccessor.hostName = this.source;
    this.pushLog("更新しました. " + this.source);
  }
}
